import styled, { css } from 'styled-components';

// Import utilities
import { customMinResponsive, flex, size } from 'components/styles';

// Import images
import { ReactComponent as Linkedin } from 'assets/icons/ic_linkedin.svg';

export const Social = styled.div`
	margin: 2.2rem 0;
	${flex({ ai: 'flex-end' })}

	${customMinResponsive(
		size.medium,
		css`
			margin: 0;
		`
	)}
`;

export const AnchorStyled = styled.a`
	${flex()}

	&:not(:last-child) {
		margin-right: 1.5rem;
		${customMinResponsive(
			size.large,
			css`
				margin-right: 6rem;
			`
		)}
	}

	svg {
		height: 2.5rem;
		width: 2.5rem;

		g {
			path {
				fill: ${({ theme }) => theme.body.footer.social};
				transition: fill 0.1s;
			}
		}
	}

	${customMinResponsive(
		size.medium,
		css`
			svg {
				height: 3.2rem;
				width: 3.2rem;
			}

			&:hover {
				svg {
					g {
						 path {
							fill: ${({ theme }) => theme.body.footer.socialHover};
						}
					}
				}
			)}
		`
	)}

	&:focus-visible {
		svg {
			g {
				path {
					fill: ${({ theme }) => theme.body.footer.socialHover};
				}
			}
		}
	}
`;

export const LinkedinStyled = styled(Linkedin)`
	height: 2.6rem !important;
`;
